import { useState } from 'react';
import { Info } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useCampaignStatusLogs } from '../api';

export function StatusLogsButton({ campaignId }: { campaignId: number | string }) {
  const [open, setOpen] = useState(false);
  const logs = useCampaignStatusLogs(Number(campaignId), open);

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-5 w-5 text-muted-foreground hover:text-foreground"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        title="View pause/resume history"
      >
        <Info className="h-3.5 w-3.5" />
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Status Logs</DialogTitle>
          </DialogHeader>

          {logs.isLoading ? (
            <p className="text-sm text-muted-foreground py-4">Loading…</p>
          ) : (logs.data ?? []).length === 0 ? (
            <p className="text-sm text-muted-foreground py-4">No status logs found.</p>
          ) : (
            <div className="max-h-80 overflow-y-auto rounded-md border border-border">
              <table className="w-full text-sm">
                <thead className="bg-muted/40 sticky top-0">
                  <tr>
                    <th className="px-3 py-2 text-left font-medium">Action</th>
                    <th className="px-3 py-2 text-left font-medium">Time</th>
                    <th className="px-3 py-2 text-left font-medium">User ID</th>
                  </tr>
                </thead>
                <tbody>
                  {(logs.data ?? []).map((log) => (
                    <tr key={log.id} className="border-t border-border">
                      <td className="px-3 py-2">
                        <Badge variant={log.action === 'RESUME' ? 'default' : 'secondary'}>
                          {log.action}
                        </Badge>
                      </td>
                      <td className="px-3 py-2">{log.createdAt || '—'}</td>
                      <td className="px-3 py-2">{log.userId}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}